import styled from '@emotion/styled'


export const Container = styled.div({
  width: '100%',
  height: '100vh',
  '.ch-main > div': {
    paddingBottom: '1rem'
  }
})

export const ContainerMain = styled.div({
  marginTop: '20px',
  padding: '0px 10% 0px 10%'
})

// export const Button = styled.div({
//   border: 'none',
//   color: 'white',
//   padding: '15px 32px',
//   textAlign: 'center',
//   textDecoration: 'none',
//   display: 'inline - block',
//   fontSize: '16px',
//   margin: '4px 2px',
//   cursor: 'pointer',
//   backgroundColor: '#FFFFFF'
// })


